import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter,
} from "@/components/ui/dialog";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";
import { useTranslation } from "react-i18next";

export default function AssignAmcDialog({ open, onOpenChange, target, amcs, amcEmail, setAmcEmail, onSubmit }) {
  const { t } = useTranslation();
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="rounded-none">
        <DialogHeader>
          <DialogTitle className="font-display">{t("ll_delegate_amc")} — {target?.name}</DialogTitle>
        </DialogHeader>
        <form onSubmit={onSubmit} className="space-y-3">
          <Label className="font-mono-label text-[10px]">{t("ll_choose_amc")}</Label>
          <Select value={amcEmail} onValueChange={setAmcEmail}>
            <SelectTrigger data-testid="amc-select" className="rounded-none">
              <SelectValue placeholder={amcs.length ? t("ll_amc_pick") : t("ll_amc_none")} />
            </SelectTrigger>
            <SelectContent>
              {amcs.map((a) => (
                <SelectItem key={a.id} value={a.email}>
                  {a.name} <span className="text-zinc-500">· {a.email}</span>
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          <div className="text-xs text-zinc-500">{t("ll_amc_help")}</div>
          <DialogFooter>
            <Button data-testid="amc-assign-submit" type="submit" disabled={!amcEmail} className="rounded-none bg-black hover:bg-zinc-800">
              {t("ll_delegate_btn")}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
